var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProjectsTableGridDot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2,
  height: 3,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7C2",
  d: "M1.003 2.115a.91.91 0 0 1-.665-.273.88.88 0 0 1-.273-.664A.87.87 0 0 1 .338.52.91.91 0 0 1 1.003.25q.375 0 .652.272a.896.896 0 0 1 .149 1.13 1 1 0 0 1-.341.34.9.9 0 0 1-.46.124"
})));
export default SvgProjectsTableGridDot;